import React, { useEffect, useState } from "react";
import Snackbar from '@mui/material/Snackbar';
import _ from "underscore";

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

import EditDialog from './edit-dialog';
import AddDialog from "./add-dialog";


function FarmOrders() {
    const [data, setData] = useState([]);
    const [showEditDialog, setShowEditDialog] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState();
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [showAddDialog, setShowAddDialog] = React.useState(false);
    const [vehicleData, setVehicleData] = useState([]);

    useEffect(() => {
        fetchData();
        fetchVehicleData();
    }, [])

    const fetchData = () => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_order`)
            .then(response => response.json())
            .then(json => setData(json))
            .catch(error => console.error(error));
    };

    const fetchVehicleData = () => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles`)
            .then(response => response.json())
            .then(json => {
                setVehicleData(json);
            })
            .catch(error => console.error(error));
    };

    const showInMapClicked = (lat, lng) => {
        window.open("https://maps.google.com?q=" + lat + "," + lng);
    };

    const handleEditOpen = () => {
        setShowEditDialog(true);
    };

    const handleEditClose = () => {
        setShowEditDialog(false);
    };

    const handleEditSave = (data) => {
        setShowEditDialog(false);
        if (data.quantity !== selectedValue.quantity || data.pickup_date !== selectedValue.pickup_date) {
            fetch(`${process.env.REACT_APP_API_URL}/farm_order/${selectedValue.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "order_no": selectedValue.order_no,
                    "farm_name": selectedValue.farm_name,
                    "location": selectedValue.location,
                    "quantity": data.quantity,
                    "pickup_date": data.pickup_date,
                    "status": selectedValue.status
                })
            })
                .then(response => response.json())
                .then(json => {
                    fetchData();
                    setShowSnackbar(true);
                    setSnackbarMessage("Data updated successfully.");
                })
                .catch(error => {
                    setShowSnackbar(true);
                    setSnackbarMessage("Error while updating data.");
                });
        } else {
            setShowSnackbar(true);
            setSnackbarMessage("No changes found.");
        }
    };

    const handleAddOpen = () => {
        setShowAddDialog(true);
    };

    const handleAddClose = () => {
        setShowAddDialog(false);
    };

    const handleAddSave = (data) => {
        if (data.order_no && data.farm_name && data.location.name && data.location.lat && data.location.lng && data.quantity && data.pickup_date) {
            setShowAddDialog(false);
            fetch(`${process.env.REACT_APP_API_URL}/farm_order`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(json => {
                    fetchData();
                    setShowSnackbar(true);
                    setSnackbarMessage("Data added successfully.");
                })
                .catch(error => {
                    setShowSnackbar(true);
                    setSnackbarMessage("Error while adding data.");
                });
        } else {
            setShowSnackbar(true);
            setSnackbarMessage("Please enter all the details.");
        }
    }

    const restoreProceedOrder = (data) => {
        const assignedVehicles = data.assigned_vehicles.split(",");
        // Update farm_order
        fetch(`${process.env.REACT_APP_API_URL}/farm_order/${data.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "order_no": data.order_no,
                "farm_name": data.farm_name,
                "location": data.location,
                "quantity": data.quantity,
                "pickup_date": data.pickup_date,
                "status": "open",
                "assigned_vehicles": "",
            })
        })
            .then(response => response.json())
            .then(json => {
                fetchData();
                setShowSnackbar(true);
                setSnackbarMessage("Order restored successfully.");
            })
            .catch(error => {
                setShowSnackbar(true);
                setSnackbarMessage("Error while restoring order.");
            });

        // Update farm_transport
        for (let i = 0; i < assignedVehicles.length; i++) {
            const element = _.findWhere(vehicleData, { vehicle_no: assignedVehicles[i] });
            fetch(`${process.env.REACT_APP_API_URL}/farm_transport_vehicles/${element.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "vehicle_id": element.vehicle_id,
                    "vendor_id": element.vendor_id,
                    "vehicle_no": element.vehicle_no,
                    "vehicle_type": element.vehicle_type,
                    "location": element.location,
                    "capacity": element.capacity,
                    "status": "available",
                    "assigned_order": "",
                    "assigned_date": ""
                })
            })
                .then(response => response.json())
                .then(json => console.log(json))
                .catch(error => console.error(error));
        };
    }

    const deleteOrder = (data) => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_order/${data.id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(json => {
                fetchData();
                setShowSnackbar(true);
                setSnackbarMessage("Data deleted successfully.");
            })
            .catch(error => {
                setShowSnackbar(true);
                setSnackbarMessage("Error while deleting data.");
            });
    };

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Order Book"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            {/* <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul> */}
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            {/* <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div> */}
                                            {/* <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div> */}
                                            <div id="plan-insert-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-table-plus" onClick={handleAddOpen}></i>
                                            </div>
                                            <div id="plan-upload-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Order No.</th>
                                                            <th>Farm Name</th>
                                                            <th>Location</th>
                                                            <th>Quantity</th>
                                                            <th>PickUp Date</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        {data.map((dt, i) =>
                                                            <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                id={`row-` + i} key={i} data-id="1">
                                                                <td data-type="text" name="order_no">
                                                                    {dt.order_no}
                                                                </td>
                                                                <td data-type="text" name="farm_name">{dt.farm_name}</td>
                                                                <td data-type="text" name="location" onClick={() => showInMapClicked(dt.location.lat, dt.location.lng)} style={{ cursor: 'pointer', color: '#134896' }}>
                                                                    {dt.location.name}
                                                                </td>
                                                                <td data-type="text" name="quantity">{dt.quantity}</td>
                                                                <td data-type="text" name="pickup_date">{new Date(dt.pickup_date).toLocaleString()}</td>
                                                                <td data-type="text" name="status" style={{ textTransform: "capitalize" }}>
                                                                    <div>{dt.status}</div>
                                                                    {dt.status === 'processed' && dt.assigned_vehicles &&
                                                                        <div>Assigned Vehicle: {dt.assigned_vehicles}</div>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {dt.status !== 'processed' &&
                                                                        <>
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-edit pr-3" onClick={() => { setSelectedValue(dt); handleEditOpen(); }}></i>
                                                                            <i className="f-24 i-btn cursor-pointer ti ti-trash-x" onClick={() => deleteOrder(dt)}></i>
                                                                        </>
                                                                    }
                                                                    {dt.status === 'processed' &&
                                                                        <i className="f-24 i-btn cursor-pointer ti ti-restore" onClick={() => restoreProceedOrder(dt)}></i>
                                                                    }
                                                                </td>
                                                            </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <EditDialog
                        selectedValue={selectedValue}
                        open={showEditDialog}
                        onClose={handleEditClose}
                        onSave={handleEditSave}
                    />
                    <AddDialog
                        open={showAddDialog}
                        onClose={handleAddClose}
                        onSave={handleAddSave}
                    />
                    <Snackbar
                        open={showSnackbar}
                        autoHideDuration={2000}
                        onClose={() => setShowSnackbar(false)}
                        message={snackbarMessage}
                    />
                </div>
            </main>
        </div>
    );
}
export default FarmOrders;